import React from 'react'
import styled from 'styled-components'
import { PageMeta } from 'components/Layout/Page'

const StyledPage = styled.div`
  min-height: calc(100vh - 240px);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px 8px;

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: auto;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 24px 16px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 32px 24px;
  }
`

const Page: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => (
  <>
    <PageMeta />
    <StyledPage {...props}>{children}</StyledPage>
  </>
)

export default Page
